import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { StripePlans } from 'src/app/models/stripe.model';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { StripeService } from 'src/app/Services/stripe.service';

@Component({
    selector: 'app-upgrade-dialog',
    templateUrl: './upgrade-dialog.component.html',
    inputs: ['upgradeDialogVisible ', 'numberOfArtTypeSelection'],
    standalone: false
})
export class UpgradeDialogComponent implements OnInit {
  public upgradeDialogVisible: boolean = false;
  public numberOfArtTypeSelection!: number;
  public isArtist: boolean = false;
  public isGallery: boolean = false;
  public authConfig: AuthConfig = {};
  public isFreePlanUser: boolean = true;
  public artistId!: string ;
  public  isStripeDisplayPlansDialogVisible = false;
  @Output() upgradeDialogVisibleChange = new EventEmitter<boolean>();
  @Output() onclose = new EventEmitter<boolean>();

  public stripePlans: StripePlans[] = [];

constructor( 
    private ngxSpinnerService:NgxSpinnerService,
    private stripeService:StripeService,
    private authService:AuthService,

){}
ngOnInit() {
    this.artistId = this.authService.getUserId();
    this.authConfig = this.authService.getAuthConfig();
    this.isArtist = this.authConfig.IsArtist || false;
    this.isGallery = this.authConfig.IsGallery || false;
    this.isFreePlanUser = this.authService.isFreePlanUser();
  }


  public ShowUpgradeDailog() {
    this.isStripeDisplayPlansDialogVisible = true;
    // this.getAllPlans();
  }

  closeDialog() {
    this.upgradeDialogVisible = false;
    this.onclose.emit(this.upgradeDialogVisible); // Emit event on close
  }

 public onCloseStripePaymentDailog($event: boolean) {
    this.isStripeDisplayPlansDialogVisible = $event;
  }
  // public getAllPlans() {
  //   if (this.isArtist || this.isGallery) {
  //     if (this.isFreePlanUser) {
  //       this.ngxSpinnerService.show();
  //       this.stripeService.getAllPlans().subscribe(
  //         (ApiResponce: StripePlans[]) => {
  //           console.log(ApiResponce);
  //           this.stripePlans = ApiResponce;
  //           this.ngxSpinnerService.hide();
  //         },
  //         (error) => { console.error(error); this.ngxSpinnerService.hide(); }
  //       );
  //     }
  //   }
  // }
}
